import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import store from './redux/store';
import { WsProvider } from './providers/WsProvider';
import { QueryClient, QueryClientProvider } from 'react-query';

import './index.css';
import { SnackbarProvider } from 'notistack';
import { ClearIcon } from './components/Icons/ClearIcon';

import { config } from './config';
import WarnMessage from './components/CustomNotistack/WarnMessage';

declare module 'notistack' {
  interface VariantOverrides {
    warn: true;
  }
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const notistackRef: any = React.createRef();
const onClickDismiss = (key) => () => {
  notistackRef?.current.closeSnackbar(key);
};

ReactDOM.render(
  <Provider store={store}>
    <SnackbarProvider
      maxSnack={5}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      // @ts-ignore
      ref={notistackRef}
      action={(key) => (
        <button onClick={onClickDismiss(key)}>
          <ClearIcon fill="white" style={{ color: 'white' }} />
        </button>
      )}
      autoHideDuration={5000}
      dense={true}
      Components={{
        warn: WarnMessage,
      }}
    >
      <QueryClientProvider client={queryClient}>
        <WsProvider>
          <App />
        </WsProvider>
      </QueryClientProvider>
    </SnackbarProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
